import { render } from "./screen.svg?vue&type=template&id=2269283d"
const script = {}
script.render = render

export default script